export default __webpack_public_path__ + "static/news-section-people2-image-88c84cdb402a9a003130741dec8f066d.webp";